import { useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { ApplicationDetailValidation, GNoValidation } from '../../../config/Validate';
import { defaultPageRowOptions, defaultRowOptions, SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import { postAllData } from '../../../service/ProductService';
import { APPLICATIONDETAILSREPORT, DOWNLOADAPPLICATIONDETAIL, DOWNLOADREGISTRATIONVALIDATION, REGVALIDATIONREPORT } from '../../../config/ApiConstant';
import { ApplicationDetailnReportListColumns, RegistrationValidationReportListColumns } from '../../../appconfig/DatatableSetting';
import { amountTemplate, combinedFullNameTemplate, dateTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { InputText } from 'primereact/inputtext';
import { downloadData, exportData } from '../../../appconfig/AppHelper';
import moment from 'moment';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';

export const ApplicationDetail = () => {
    document.title = 'Application Detail | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);
    // Date Object
    let today = new Date();
    const [dates, setDates] = useState<string | Date | Date[] | any | null>([new Date(today.setDate(today.getDate() - 31)), new Date()]);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [errors, setErrors] = useState<any>({});
    const [registrationVlidationList, setApplicationDetailList] = useState<any>([]);
    const [regDetails, setRegDetails] = useState<any>({});
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [exportLoader, setExportLoader] = useState<boolean>(false);
    const [applicationDetails, setApplicationDetails] = useState<any>({});
    const [loading, setLoading] = useState<boolean>(false);
    const [showButton, setShowButton] = useState<boolean>(false);

    const handleChange = (e: any, name: string) => {
        let val = (e.target && e.target.value) || e.value || '';
        setRegDetails({ ...regDetails, [name]: val });
    };

    // Get Name
    let full_name = `${!window.cn(applicationDetails?.StudL) ? applicationDetails?.StudL : ''} ${!window.cn(applicationDetails?.StudF) ? applicationDetails?.StudF : ''} ${!window.cn(applicationDetails?.StudM) ? applicationDetails?.StudM : ''}`;

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <div>
                    <div className="input-effect-div">
                        <InputText value={regDetails?.reg_no} name="reg_no" autoComplete="off" placeholder="Enter Reg No" onChange={(e) => handleChange(e, 'reg_no')} className={errors['reg_no'] && 'p-invalid'} />
                        <span className="focus-bg"></span>
                    </div>

                    <small className="p-invalid-txt">{errors['reg_no']}</small>
                </div>

                <div>
                    <div className="input-effect-div">
                        <InputText value={applicationDetails?.SrNo} name="file_no" autoComplete="off" placeholder="File No" disabled className="ml-3" />
                        <span className="focus-bg"></span>
                    </div>
                </div>

                <div>
                    <div className="input-effect-div">
                        <InputText value={!window.cn(full_name) ? full_name : ''} name="name" autoComplete="off" placeholder="Full Name" disabled className="ml-3" style={{ minWidth: '500px' }} />
                        <span className="focus-bg"></span>
                    </div>
                </div>

                <Button label="Show" onClick={() => getApplicationDetail()} loading={showLoading} className="ml-3"></Button>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-file-export" label="Export" onClick={() => exportCSV()} className="p-button-success" loading={exportLoader} disabled={showButton ? false : true}></Button>
                <Button icon="pi pi-download" label="Download" onClick={() => downloadAllData()} className="mx-2" loading={loading} disabled={showButton ? false : true}></Button>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined ml-2"></Button>
            </>
        );
    };

    //downloadDAta
    const downloadAllData = async () => {
        try {
            setLoading(true);

            let startDate = moment(dates[0]).format('y-M-D') + ' 00:00:00';
            let endDate = moment(dates[1]).format('y-M-D') + ' 23:59:59';

            // Request Data
            const requestData = {
                start_date: startDate,
                end_date: endDate,
                reg_no: regDetails?.reg_no
            };

            const response = await downloadData(DOWNLOADAPPLICATIONDETAIL, 'Application_Details_Report', requestData);
            if (response === true) {
                setLoading(false);
            } else if (response === false) {
                setLoading(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    //export CSv
    const exportCSV = async () => {
        setExportLoader(true);

        let res = await exportData('Application_Details_Report');
        if (res === true) {
            setExportLoader(false);
        } else {
            setExportLoader(false);
        }
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // getApplicationDetailList
    const getApplicationDetail = async () => {
        try {
            const { errors, isError } = ApplicationDetailValidation(regDetails);
            setErrors(errors);
            if (!isError) {
                setPageLoad(false);
                setShowLoading(true);

                let startDate = moment(dates[0]).format('y-M-D') + ' 00:00:00';
                let endDate = moment(dates[1]).format('y-M-D') + ' 23:59:59';

                // Request Data
                const requestData = {
                    start_date: startDate,
                    end_date: endDate,
                    reg_no: regDetails?.reg_no
                };

                const response = await postAllData(APPLICATIONDETAILSREPORT, requestData);
                if (response) {
                    setPageLoad(true);
                    setShowLoading(false);
                    setApplicationDetailList(response?.list);
                    setApplicationDetails(response?.details);
                    setShowButton(true);
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPageLoad(true);
                setShowLoading(false);
                setShowButton(false);

                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    const billNoTemplate = (rowData: any) => {
        return <>{!window.cn(rowData?.CrYear) && !window.cn(rowData?.BillSrNo) ? rowData?.CrYear + '/' + rowData?.BillSrNo : ''}</>;
    };

    return (
        <>
            <AppBreadcrumb currentMenu={'Reports'} pageName={'Application Detail'} pageTitle={'Application Detail'} goToPage={true} />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={registrationVlidationList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Data Found"
                                    removableSort
                                >
                                    {ApplicationDetailnReportListColumns.map((col: any, i: any) => {
                                        if (col.field === 'PayDt') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} />;
                                        } else if (col.field === 'NetAmt') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={amountTemplate} />;
                                        } else if (col.field === 'bill_no') {
                                            return <Column key={col.field} header={col.header} body={billNoTemplate} />;
                                        } else if (col.field === 'sr_no') {
                                            return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '4rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {ApplicationDetailnReportListColumns.map((col: any, i: any) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
